import React from 'react';
import {SERVER_HEADER_MENU, SERVER_LINKS} from "../../constants";
import {isDesktop} from "../../utils";

const Header = () => {
  const links = SERVER_LINKS;
  const headerMenuItems = SERVER_HEADER_MENU;

  let menuItems = [];
  for(let item of headerMenuItems) {
    let tooltipHtml = '';
    if (item.tooltip) {
      tooltipHtml = <div className="h-ml__tooltip">{item.tooltip}</div>
    }

    menuItems.push(
        <li className="h-ml__nav--item" key={item.label}>
          <a className="h-ml__nav--item-link" href={item.url} title={item.label}>
            {item.label}
          </a>
          {tooltipHtml}
        </li>
    );
  }

  return (
      <header>
        <div className="h-s visible-s">
          <div className="h-s">
            <div className="h-s__elements">
              <div className="h-s__item h-s__logo">
                <a className="h-s__logo-link" href={links.home}>
                  <i className="h-s__logo-image" />
                </a>
              </div>
              <div
                  className="h-s__item login-s txt-r"
                  style={{ display: isDesktop() ? 'table-cell' : 'none' }}
              />
            </div>
          </div>
        </div>

        <div className="hidden-s old-header">
          <div className="h-ml">
            <div className="container">
              <div className="h-ml__logo">
                <a className="h-ml__logo--link" href={links.home} title="Bet9ja">
                  <i className="h-ml__logo--image" />
                </a>
              </div>

              <div className="h-ml__nav">
                <ul className="h-ml__nav__list">
                  {menuItems}
                </ul>
              </div>
            </div>
          </div>

          <nav className="h-ml__subnav">
            <div className="container">
              <div className="h-ml__subnav__holder">
                <div className="h-ml__subnav--item" />

                <div className="h-ml__subnav--item h-ml__subnav__socials" />

                <div className="h-ml__subnav--item h-ml__subnav__timezone">
                  <div className="h-ml__subnav__timezone--item">
                    <span className="h-ml__subnav__timezone--item-text">
                      GMT{' '}
                    </span>
                    <span className="h-ml__subnav__timezone--item-text">
                      +01:00
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
  );
}

export default Header;
